<template>
  <div v-if="navData.tab_buttons" class="col-12 pt-3 pb-1 pl-3 bg-primary text-white shadow-sm">
    <h1>{{ getPageName()}}</h1>
  </div>
</template>

<script>
export default {
  props: ['navData'],
  methods: {
    getPageName() {
      for (let a = 0; a < this.tab_buttons_length; a += 1) {
        if (this.navData.page_name === this.navData.tab_buttons[a].name) {
          return this.navData.tab_buttons[a].label;
        }
      }
      return true;
    },
  },
  computed: {
    tab_buttons_length() {
      return (typeof this.navData.tab_buttons !== 'undefined' ?
        (this.navData.tab_buttons.length) : null);
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/interview/shared/NavigationTitle.vue?6562c119